<template>
  <v-container
    class="ma-0 pa-0 grey lighten-4"
    fluid
    fill-height
    ref="chatContainer"
  >
    <v-layout>
      <v-flex>
        <v-layout
          align-center
          justify-center
          column
          fill-height
        >
          <v-toolbar
            flat
            dense
            color="grey lighten-3"
          >
            <v-spacer />
            <v-btn
              flat
              small
              @click="chatFilterDialog = true"
              :color="chatFilter && Object.keys(chatFilter).length ? 'primary' : 'grey darken-2'"
            >
              <v-icon small>filter_list</v-icon> {{ chatFilter && Object.keys(chatFilter).length ? 'סינון (פעיל)' : 'סינון' }}
            </v-btn>
            <v-spacer />
          </v-toolbar>
          <v-flex
            fill-height
            class="messages-container"
            :id="compId"
          >
            <fullpage-loader
              message="טוען צ׳אט..."
              v-if="loading"
            ></fullpage-loader>
            <chat-messages
              style="position: relative;"
              :chat-id="chatId"
              :chat-component-id="compId"
              v-if="!loading"
            />
          </v-flex>
          <v-flex style="width: 100%;">
            <chat-footer
              :chat-id="chatId"
              :chat-component-id="compId"
            />
          </v-flex>
        </v-layout>

      </v-flex>

    </v-layout>

    <chat-filter-dialog :comp-id="compId" />
  </v-container>
</template>

<script>
import ChatFooter from "./ChatFooter.vue";
import ChatMessages from "./Messages.vue";
import ChatFilterDialog from "./ChatFilterDialog.vue";
import FullpageLoader from "../FullpageLoader.vue";
import generateId from "@/idGenerator";

export default {
  data() {
    return {
      compId: null,
      loading: true,
      items: ["יומן אירוע", "תחקיר"],
      chips: []
    };
  },

  data() {
    return {
      compId: null,
      loading: true,
      items: ["יומן אירוע", "תחקיר"],
      chips: [],
      currentChatId: null
    };
  },

  computed: {
    chatId() {
      return this.currentChatId;
    },
    chatFilterDialog: {
      get() {
        return this.$store.getters["chats/chatFilterDialog"](this.compId);
      },
      set(val) {
        this.$store.commit("chats/SET_CHAT_FILTER_DIALOG", {
          val,
          compId: this.compId
        });
      }
    },
    chatFilter() {
      return this.$store.getters["chats/filter"](this.compId);
    }
  },

  methods: {
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
    updateChatId() {
      // Get event IDs to show from store
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      
      if (eventIdsToShow.length === 1) {
        // Single event - find the chat ID for that event
        let chat = Object.values(this.$store.state.entities.chats).find(item => {
          return item.event === eventIdsToShow[0];
        });
        console.log('Chat updateChatId - eventIdsToShow:', eventIdsToShow);
        console.log('Chat updateChatId - found chat:', chat);
        this.currentChatId = chat ? chat._id : null;
      } else {
        // Multiple events - set to null to indicate we need to fetch all chats
        this.currentChatId = null;
      }
      console.log('Chat updateChatId - currentChatId set to:', this.currentChatId);
    },
    fetchChat() {
      this.loading = true;
      
      // Clear existing messages when switching events
      this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
      
      // Get event IDs to show from store
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      console.log('Chat fetchChat - eventIdsToShow:', eventIdsToShow);
      
      // Ensure we have valid event IDs
      if (!eventIdsToShow || eventIdsToShow.length === 0) {
        console.log('Chat fetchChat - no event IDs to show, skipping fetch');
        this.loading = false;
        return;
      }
      
      this.$store
        .dispatch("API_GET", {
          url: "/chats",
          entityType: "chat",
          schema: "chatListSchema",
          params: {
            q: JSON.stringify({ event: { $in: eventIdsToShow } })
          },
          replace: true
        })
        .then(() => {
          // Update chat ID after fetching chats
          this.updateChatId();
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {
    this.fetchChat();
    this.compId = generateId();
    
    // Listen for global refetch event
    this.$bus.$on('refetch-all-data', () => {
      console.log('Chat - received global refetch event');
      this.fetchChat();
    });
  },

  watch: {
    // Watch for event IDs to show changes (כולם mode)
    '$store.state.events.eventIdsToShow': {
      handler(newVal, oldVal) {
        console.log('Chat watcher - eventIdsToShow changed from:', oldVal, 'to:', newVal);
        // Clear messages first, then fetch new data
        this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
        this.fetchChat();
      },
      deep: true
    },
    // Watch for route changes to refetch data when switching events
    '$route.params.id': {
      handler(newEventId, oldEventId) {
        console.log('Chat watcher - route changed from:', oldEventId, 'to:', newEventId);
        if (newEventId && newEventId !== oldEventId) {
          // Clear messages first, then fetch new data
          this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
          this.fetchChat();
          // Update chat ID after a short delay to ensure chats are loaded
          setTimeout(() => {
            this.updateChatId();
          }, 100);
        }
      },
      immediate: true
    },
    // Watch for showAllEvents changes (כולם toggle)
    '$store.state.events.showAllEvents': {
      handler(newShowAll, oldShowAll) {
        console.log('Chat watcher - showAllEvents changed from:', oldShowAll, 'to:', newShowAll);
        // Clear messages first, then fetch new data
        this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
        this.fetchChat();
      }
    },
    // Watch for chats store changes to update chatId
    '$store.state.entities.chats': {
      handler(newChats, oldChats) {
        console.log('Chat watcher - chats in store changed');
        console.log('Chat watcher - new chats count:', Object.keys(newChats).length);
        // Update chat ID when chats are loaded
        this.updateChatId();
      },
      deep: true
    },
    // Watch for event ID changes to refetch data
    eventId: {
      handler(newEventId, oldEventId) {
        console.log('Chat watcher - eventId prop changed from:', oldEventId, 'to:', newEventId);
        if (newEventId && newEventId !== oldEventId) {
          // Clear messages and refetch for new event
          this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
          this.fetchChat();
        }
      },
      immediate: true
    }
  },

  beforeDestroy() {
    // Clean up global event listener
    this.$bus.$off('refetch-all-data');
  },

  props: ["eventId"],

  components: {
    ChatFooter,
    ChatMessages,
    FullpageLoader,
    ChatFilterDialog
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.messages-container {
  width: 100%;
  overflow: scroll;
}
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chat/Chat.vue